import React from "react";
import PropTypes from "prop-types";

const RenderIf = props => {
    return props.if ? props.render() : <></>;
};

RenderIf.propTypes = {
    if: PropTypes.bool,
    render: PropTypes.func.isRequired
};

export default RenderIf;
